// extracted by mini-css-extract-plugin
module.exports = {"error":"Error404_error__gWb5I","button":"Error404_button__MZSoc","div":"Error404_div__2uIK6","h1":"Error404_h1__Ju3oP","h3":"Error404_h3__2QL9Z"};